// extracted by mini-css-extract-plugin
module.exports = {"icon":"DesktopIcon_icon_1XyFR","text":"DesktopIcon_text_1vTkZ","root":"DesktopIcon_root_D_7BU"};